// import type from types.ts
import { UropProject } from '../../../types'; // don't remove this line

// import the thumbnail image
import thumbnailImage from './humanoid.jpg'; // modify this import based on your image name

// import the new html file you wrote
const htmlContent = require('./article.html');

// edit the project object below with your UROP project's info
const project: UropProject = {
  title: 'Developing a Perception Pipeline for MIT Humanoid Robot',
  description: `This project aims to develop an egocentric perception pipeline for humanoid sports applications (e.g., soccer). 
  The student will work on camera-to-IMU calibration and design a perception software stack for the humanoid robot. 
  The primary outcome will be a ball state estimation framework that processes RGB-D images to infer the ball's position, velocity, and other relevant properties.`,
  thumbnail: thumbnailImage,
  html: htmlContent,
  id: 'humanoid-perception',
  semester: 'Fall 2025',
};

export default project;